import {
  Component,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { Store, select } from '@ngrx/store';
import {
  UIPathConnList,
  getCurrentUIPathConn,
  ResetUIPathState
} from './store/actions/rpa-uipath-conn.actions';
import {
  getUIPathConnList,
  getIsLoadingList
} from './store/selectors/rpa-uipath-conn.selector';
import { Observable, Subscription } from 'rxjs';
import { UiPathDetailWrapperComponent } from './uipath-detail-wrapper/uipath-detail-wrapper.component';
import { BotsListComponent } from 'app/rpa-bots/shared/bots-list/bots-list.component';
import { EListSelectionStatus, RpaBotType } from '../core/rpa-bots-type.enum';
import { PendingChangesService } from 'app/rpa-bots/core/pending-changes.service';
import { IAppState } from 'app/IAppState';
import { IRpaConnectionUiPath } from '../core/IRpaBots';

@Component({
  selector: 'uipath',
  templateUrl: 'uipath.component.html',
  styleUrls: ['uipath.component.scss']
})
export class UipathComponent implements AfterViewInit {
  private _isLoadingListSubscription: Subscription;
  @ViewChild('uiPathDetailWrapper', { static: false})
  private _uiPathDetailWrapperComponent: UiPathDetailWrapperComponent;
  @ViewChild('botsList', { static: false}) private _botsList: BotsListComponent;

  uiPathList$: Observable<IRpaConnectionUiPath[]>;
  isLoading$: Observable<boolean>;

  constructor(private _store: Store<IAppState>,
    private _pendingChangesService: PendingChangesService) {
    this.uiPathList$ = this._store.pipe(select(getUIPathConnList));
    this.isLoading$ = this._store.pipe(select(getIsLoadingList));
  }

  ngOnInit() {
    this._store.dispatch(new UIPathConnList());
    this._isLoadingListSubscription = this.isLoading$.subscribe((isLoading: boolean) => {
      this._pendingChangesService.afterConnectorUpdated(isLoading);
    });
  }

  ngAfterViewInit() {
    this._pendingChangesService.initialize(this._store,
      this._uiPathDetailWrapperComponent,
      this._botsList,
      RpaBotType.UiPath,
      EListSelectionStatus.unselect);
  }

  ngOnDestroy(): void {
    this._store.dispatch(new ResetUIPathState());
    if (this._isLoadingListSubscription) {
      this._isLoadingListSubscription.unsubscribe();
    }
  }

  onSelectedBotChanged(bot: IRpaConnectionUiPath) {
    this._pendingChangesService.listSelectionStatus = EListSelectionStatus.loading;
    if (!!this._pendingChangesService.selectedConnector) {
      this._pendingChangesService.nextConnector = bot;
      this._pendingChangesService.check();
    } else {
      this._pendingChangesService.selectedConnector = bot;
      this._botsList.currentBot = bot;
      this._store.dispatch(new getCurrentUIPathConn(bot.id));
    }
  }
}
